import { Prompt } from "./types";
import { gigaParty } from "../party";
import { addUserMessage } from "./add-user-message";

/**
 * Create a completion with shell chat UI. Returns a stream
 * @param prompts
 */
export const completionsCreateWithUi = (prompts: Prompt[], messageId: string) => {
    return new Promise((resolve, reject) => {
        // Use the provided messageId
        const id = messageId;

        addUserMessage({
            role: 'user',
            context: prompts[0].content,
            id // Include id here if needed
        })

        gigaParty.send(JSON.stringify({
            id,
            key: 'gigakit.shell.ai.completion',
            data: {
                messages: prompts,
                id  // Include id here
            }
        }))

        resolve({
            success: true,
        });
    });
};
